import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import type { ExperienceDetail } from "@/mocks/experienceDetails";

export default function ExperienceInfo({ detail }: { detail: ExperienceDetail }) {
  return (
    <section className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              Good To Know
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl leading-tight text-foreground-950 font-semibold">
            How Your Day Is Shaped
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <Reveal className="lg:col-span-6">
            <div className="h-full bg-background-100 rounded-lg border border-background-200 p-7 md:p-9">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-walk-line text-2xl"></i>
              </span>
              <h3 className="font-heading text-2xl text-foreground-950 font-semibold mt-5">
                What You Will Do
              </h3>
              <ul className="mt-6 space-y-4">
                {detail.whatYouWillDo.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <div className="lg:col-span-6 grid grid-cols-1 gap-6 md:gap-8">
            <Reveal delay={90}>
              <div className="bg-secondary-50 rounded-lg border border-secondary-200 p-7 md:p-9">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className="ri-gift-line text-2xl"></i>
                </span>
                <h3 className="font-heading text-2xl text-foreground-950 font-semibold mt-5">
                  What's Included
                </h3>
                <div className="flex flex-wrap gap-2 mt-6">
                  {detail.includes.map((item) => (
                    <span
                      key={item}
                      className="text-xs font-medium bg-background-50 text-secondary-800 border border-secondary-200 px-3 py-1.5 rounded-full"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>

            <Reveal delay={160}>
              <div className="bg-accent-50 rounded-lg border border-accent-200 p-7 md:p-9">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-lightbulb-line text-2xl"></i>
                </span>
                <h3 className="font-heading text-2xl text-foreground-950 font-semibold mt-5">
                  Good To Know
                </h3>
                <ul className="mt-6 space-y-3">
                  {detail.goodToKnow.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0 mt-0.5">
                        <i className="ri-information-line text-sm"></i>
                      </span>
                      <span className="text-sm text-foreground-700 leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}